import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useWatch } from 'react-hook-form';
import JSONPretty from 'react-json-pretty';

const dataProviderName = 'advertisings/source';
const model = 'advertisings/source';
const modelExposedName = 'Source';
const wizardAction = 'manageBudgetAndGoals';

const BudgetAndGoals = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [costGroupSelectorParams, setCostGroupSelectorParams] = useState({ _related_area_id: null, year: new Date().getFullYear() });
    const [detailConfig, setDetailConfig] = useState();
    const modelName = existingModules.modelName

    // DATA PROVIDER
    const { items, loadAll, success, errorMessage, errors, saving, loading } = useDataProvider(dataProviderName);
    const { items: areas, loadAll: loadAllAreas, doAction: doActionAreas, loading: loadingAreas } = useDataProvider('commercials/area');
    const { items: areasources, loadAll: loadAllAreaSources, doAction: doActionAreaSources, loading: loadingAreaSources, saving:savingAreaSources } = useDataProvider('commercials/areaSource');

    const itemsLoaded = useRef(false);
    const areasLoaded = useRef(false);
    const [editing, setEditing] = useState(false)
    const [dataComplete, setDataComplete] = useState(false)
    const [budgetValues, setBudgetValues] = useState([])
    const [centralTotalBudget, setCentralTotalBudget] = useState(0)
    const [localTotalBudget, setLocalTotalBudget] = useState(0)
    const [totalLeadGoal, setTotalLeadGoal] = useState(0)
    const [totalProposalGoal, setTotalProposalGoal] = useState(0)
    const [totalWinGoal, setTotalWinGoal] = useState(0)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doActionAreaSources && doActionAreaSources({ action: wizardAction, model: 'commercials/areaSource', data: data });
    }

    const onChangeFieldValueAction = (field, value, setFormValues, stepActive, setValue, getValues) => {

        if (costGroupSelectorParams.hasOwnProperty(field)) {
            const newparams = { ...costGroupSelectorParams };
            newparams[field] = value;
            prepareDetailConfig(areas, []);
            setCostGroupSelectorParams(newparams)
        } else {
            const areasource_id = field.split('_')[1];
            const key = field.split('_')[0];
            const areasource = areasources.find((areasource) => areasource._id == areasource_id);

            areasource[key] = parseInt(value);
            prepareInfoHeaderValues();
        }
    }

    const handleValueChange = (a, b, c) => {
        console.info(a, b, c);
    }

    useEffect(() => {
        loadAll({
            items: [
                {
                    field: "active",
                    operator: 'equals',
                    value: "true"
                }
            ]
        });
    }, [])

    useEffect(() => {
        if (!items || items.length == 0 || itemsLoaded.current) return;
        loadAllAreas();
        itemsLoaded.current = true;

    }, [items])

    useEffect(() => {
        if (!areas || areas.length == 0 || areasLoaded.current) return;

        prepareDetailConfig(areas, areasources);
        areasLoaded.current = true;

    }, [areas])

    const prepareDetailConfig = (areas, areasources) => {

        const detailConfig = {
            "tabs": [
                {
                    "name": "management",
                    "fieldsets": [
                        {
                            "name": "filters",
                            "fields": {
                                "_related_area_id": {
                                    "type": "select",
                                    "label": "area",
                                    "className": "col-6",
                                    "required": true,
                                    "options": getSelectableAreas(areas)
                                },
                                "year": {
                                    "type": "select",
                                    "label": "year",
                                    "className": "col-6",
                                    "required": true,
                                    "options": [
                                        { label: 2019, value: 2019 },
                                        { label: 2020, value: 2020 },
                                        { label: 2021, value: 2021 },
                                        { label: 2022, value: 2022 },
                                        { label: 2023, value: 2023 },
                                        { label: 2024, value: 2024 },
                                        { label: 2025, value: 2025 },
                                        { label: 2026, value: 2026 },
                                        { label: 2027, value: 2027 },
                                        { label: 2028, value: 2028 },
                                        { label: 2029, value: 2029 },
                                        { label: 2030, value: 2030 }
                                    ]
                                },
                            }
                        }
                    ]
                }
            ],
            "validation": []
        };

        let fieldsetCosts;

        const allValuesSet = Object.values(costGroupSelectorParams).every(value => value !== null && value !== undefined);

        if (areasources.length > 0) {
            fieldsetCosts = {
                "name": "budget",
                "fields": getBudgetFields(areasources)
            }
        } else if (allValuesSet || (loading || loadingAreas || loadingAreaSources)) {
            fieldsetCosts = {
                "name": "budget",
                "fields": {
                    "loading_data": {
                        "type": "sectionmessageblock",
                        "title": "loading_message_title",
                        "paragraph": "loading_message_paragraph",
                        "icon": "faClock",
                        "className": "col-12 warning",
                    }
                }
            }
        } else {
            fieldsetCosts = {
                "name": "budget",
                "fields": {
                    "complete_data": {
                        "type": "sectionmessageblock",
                        "title": "complete_data_budget_message_title",
                        "paragraph": "complete_data_budget_message_paragraph",
                        "icon": "faPen",
                        "className": "col-12 info",
                    }
                }
            }
        }
        detailConfig.tabs[0].fieldsets.push(fieldsetCosts);

        prepareInfoHeaderValues();
        prepareBudgetValues();
        setDetailConfig(detailConfig);
    }

    const getSelectableAreas = (areas) => {
        return areas
            .filter((area) => area.name)
            .map((area) => ({ "label": area.name, "value": area._id }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    const getBudgetFields = (areasources) => {
        
        const budgetFields = areasources
            .sort((a, b) => {
                const nameA = String(a._related_source_name || a.name || '');
                const nameB = String(b._related_source_name || b.name || '');
                return nameA.localeCompare(nameB);
            })
            .reduce((fields, areasource) => {
                fields["ChannelName_" + areasource._original_id] = {
                    "type": "sectiontitle",
                    "label": areasource._related_source_name || areasource.name.split(' | ')[1] || '',
                    "subtitle": [t(areasource._related_source_category), t(areasource._related_source_type), areasource.active ? t('active') : t('inactive')].join(' | '),
                    "className": "col-2"
                };

                fields["budgetCentrale_" + areasource._original_id] = {
                    "type": "number",
                    "icon": "faGlobe",
                    "label": "Budget Centrale",
                    "className": "col-2",
                    "readonly":  areasource._related_source_canHaveCost != "true"
                };
                fields["budgetLocale_" + areasource._original_id] = {
                    "type": "number",
                    "icon": "faShop",
                    "label": "Budget Locale",
                    "className": "col-2",
                    "readonly":  areasource._related_source_canHaveCost != "true"
                };
                fields["leadGoal_" + areasource._original_id] = {
                    "type": "number",
                    "icon": "faBullseyeArrow",
                    "label": "Ob. Lead",
                    "className": "col-2",
                    "readonly":  areasource._related_source_canHaveLead != "true"
                };
                fields["proposalGoal_" + areasource._original_id] = {
                    "type": "number",
                    "icon": "faBullseyeArrow",
                    "label": "Ob. Proposte",
                    "className": "col-2",
                    "readonly":  areasource._related_source_canHaveLead != "true"
                };
                fields["winGoal_" + areasource._original_id] = {
                    "type": "number",
                    "icon": "faBullseyeArrow",
                    "label": "Ob. Accettate",
                    "className": "col-2",
                    "readonly":  areasource._related_source_canHaveLead != "true"
                };

                return fields;
            }, {});

        //console.info('..........getBudgetFields', budgetFields);
        return budgetFields;
    }

    const prepareInfoHeaderValues = () => {
        let centralTotalBudget = 0;
        let localTotalBudget = 0;
        let totalLeadGoal = 0;
        let totalProposalGoal = 0;
        let totalWinGoal = 0;
        // popolo i totali da erogare in infoHeader
        areasources.forEach(areasource => {
            //console.info("prepareBudgetValues", areasource.name, areasource.budgetCentrale, areasource)
            centralTotalBudget += areasource.budgetCentrale ?? 0;
            localTotalBudget += areasource.budgetLocale ?? 0;
            totalLeadGoal += areasource.leadGoal ?? 0;
            totalProposalGoal += areasource.proposalGoal ?? 0;
            totalWinGoal += areasource.winGoal ?? 0;
        });

        setCentralTotalBudget(centralTotalBudget);
        setLocalTotalBudget(localTotalBudget);
        setTotalLeadGoal(totalLeadGoal);
        setTotalProposalGoal(totalProposalGoal);
        setTotalWinGoal(totalWinGoal);
    }

    const prepareBudgetValues = () => {
        // creo le posizioni di costo in base alle areasources esistenti
        //console.info("prepareBudgetValues", areasources)
        const budgetValues = areasources.reduce((acc, areasource) => {
            acc['budgetCentrale_' + areasource._id] = areasource.budgetCentrale ?? 0; // valore di default
            acc['budgetLocale_' + areasource._id] = areasource.budgetLocale ?? 0; // valore di default
            acc['leadGoal_' + areasource._id] = areasource.leadGoal ?? 0; // valore di default
            acc['proposalGoal_' + areasource._id] = areasource.proposalGoal ?? 0; // valore di default
            acc['winGoal_' + areasource._id] = areasource.winGoal ?? 0; // valore di default
            return acc;
        }, {});

        //console.info("prepareBudgetValues", 'centralTotalBudget', centralTotalBudget, 'localTotalBudget', localTotalBudget)
        setBudgetValues(budgetValues);
    }

    const getFiltersToLoadAreaSources = () => {
        // preparo i filtri per la query sulla collection areasource
        // a) tutti i filtri tranne le budget type e month
        const filterItems = Object.entries(costGroupSelectorParams).map(([field, value]) => {
            if (['budgetType', 'month', 'key'].includes(field)) return null
            return {
                field: field,
                operator: 'equals',
                value: value
            }
        }).filter((item) => item !== null)

        return filterItems;
    }

    useEffect(() => {
        const allValuesSet = Object.values(costGroupSelectorParams).every(value => value !== null && value !== undefined);

        if (allValuesSet) {
            setDataComplete(false);
            //console.info('1 useEffect[costGroupSelectorParams] lancio loadAllAreaSources', getFiltersToLoadAreaSources());
            loadAllAreaSources({
                items: getFiltersToLoadAreaSources()
            }).then((res) => {
                //console.info('2 useEffect[costGroupSelectorParams] ho ottenuto le areasources', res?.items?.data);
                if ((res?.items?.data ?? []).length > 0) {
                    setDataComplete(true)
                } else {
                    setDataComplete(-1)
                }
            })
        }
    }, [costGroupSelectorParams])

    useEffect(() => {
        if (dataComplete == -1) {
            //console.info('4 useEffect[dataComplete] lancio doActionAreas ', dataComplete, { area_id:costGroupSelectorParams._related_area_id, year:costGroupSelectorParams.year, source_ids: items.map((source) => source._id) });
            doActionAreas && doActionAreas({ action: 'createAreaSources', model: 'commercials/area', data: { area_id: costGroupSelectorParams._related_area_id, year: costGroupSelectorParams.year, source_ids: items.map((source) => source._id) } }).then((res) => {
                //console.info('5 useEffect[dataComplete] Ho creato le area sources ', res, 'rilancio effect per caricarle');
                setDataComplete(false);
                prepareDetailConfig(areas, areasources)
                setCostGroupSelectorParams({ ...costGroupSelectorParams });
            });

        } else if ((areasources ?? []).length == 0) {
            //console.info('6 useEffect[dataComplete] KO AREA SOURCES È VUOTO', areasources);
            setDataComplete(false);
        } else {
            //console.info('6 useEffect[dataComplete] OK POSSO PROCEDERE PERCHÈ AREA SOURCES SONO POPOLATE ', areasources);
            prepareDetailConfig(areas, areasources)
        }
    }, [dataComplete])

    return (
        <>
            {/* <JSONPretty data={budgetValues} className={'json-wrapper'} /> */}
            <DetailComponent
                values={{
                    ...costGroupSelectorParams,
                    ...budgetValues,
                    areasource_ids: areasources.map((areasource) => areasource._id)
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={savingAreaSources}
                loading={!areasLoaded.current}
                errors={errors}
                errorMessage={errorMessage}
                title={t('Manage yearly budget')}
                canSave={dataComplete && userCapabilities && userCapabilities[dataProviderName + '.edit']}
                header={
                    <InfoHeader
                        view="budgetAndGoal"
                        title={t('Manage yearly budget')}
                        subtitle={t('Select an Area to manage the related yearly budget')}
                        central={centralTotalBudget}
                        local={localTotalBudget}
                        leadGoal={totalLeadGoal}
                        proposalGoal={totalProposalGoal}
                        winGoal={totalWinGoal}
                    />
                }
                {...params}
                onChangeFieldValueAction={onChangeFieldValueAction}
            />
        </>
    )
}

export default BudgetAndGoals